import { render, staticRenderFns } from "./addTask.vue?vue&type=template&id=4cadc806&scoped=true"
import script from "./addTask.vue?vue&type=script&lang=js"
export * from "./addTask.vue?vue&type=script&lang=js"
import style0 from "./addTask.vue?vue&type=style&index=0&id=4cadc806&prod&lang=scss&scoped=true"
import style1 from "./addTask.vue?vue&type=style&index=1&id=4cadc806&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cadc806",
  null
  
)

export default component.exports